<app-dialog-heading [heading]="heading"></app-dialog-heading>


<mat-dialog-actions align="center" class="dialog-button-container flex">
  
  <!---------------------------->
  <!--  Revert Button -->
  <!---------------------------->
  <ng-container *ngIf="!confirmRevertAction && !confirmReverseAction">
    <button class="dialog-button" mat-raised-button
            [disabled]="isPharmacyClaim" color="primary"
            (click)="onClickActionTypeSelected(actionType.Revert)">
      Revert for Reprocessing
      <mat-icon *ngIf="isPharmacyClaim" class="info-icon"
                [matTooltip]="'Pharmacy claims cannot be reverted for reprocessing'">help_outline
      </mat-icon>
    </button>
  </ng-container>
  
  
  <ng-container *ngIf="confirmRevertAction">
    <ng-container
      *ngTemplateOutlet="confirmation; context: {
       actionType: actionType.Revert,
       confirmationText: 'Are you sure you want to revert the claim for reprocessing?'
       }">
    </ng-container>
  </ng-container>
  
  <!---------------------------->
  <!--  Reverse Button -->
  <!---------------------------->
  <ng-container *ngIf="!confirmRevertAction && !confirmReverseAction">
    <button class="dialog-button" mat-raised-button color="primary"
            (click)="onClickActionTypeSelected(actionType.Reverse)">
      Reverse Claim
    </button>
  
  </ng-container>
  
  <ng-container *ngIf="confirmReverseAction">
    <ng-container
      *ngTemplateOutlet="confirmation; context: {
       actionType: actionType.Reverse,
       confirmationText: 'Are you sure you want to reverse the claim?'
       }">
    </ng-container>
  </ng-container>
  
  
  <!--  Confirmation Icons -->
  <ng-template #confirmation
               let-confirmationText="confirmationText"
               let-actionType="actionType">
    <span class="font-medium">{{confirmationText}} &nbsp;</span>
    <mat-icon class="mat-primary-color hand-cursor font-medium mt1"
              matTooltip="CONFIRM"
              (click)="onClickActionTypeConfirmed($event, actionType)">
      done
    </mat-icon>
    <mat-icon class="hand-cursor font-medium mt1"
              matTooltip="CANCEL"
              color="warn"
              (click)="onClickToggleIcons($event, actionType)">
      close
    </mat-icon>
  </ng-template>

</mat-dialog-actions>
